export default {
  init (vue) {
    return {
      sendVerifyCode(data) {
        return vue.$http({
          method: 'POST',
          url: `/shop/common/sendVerifyCode`,
          data: {
            ...data
          }
        })
      },
      createActPayOrder(data) {
        return vue.$http({
          method: 'POST',
          url: `/shop/wxpay/createActPayOrder`,
          data: {
            ...data
          }
        })
      },
      queryPayOrder(data) {
        return vue.$http({
          method: 'GET',
          url: `/shop/wxpay/queryPayOrder`,
          params: {
            ...data
          }
        })
      },
      sendWXPayVerifyCode(data) {
        return vue.$http({
          method: 'GET',
          url: `/shop/wxpay/sendVerifyCode`,
          params: {
            ...data
          }
        })
      },
      checkVerifyCode(data) {
        return vue.$http({
          method: 'GET',
          url: `/shop/wxpay/checkVerifyCode`,
          params: {
            ...data
          }
        })
      },
      queryPapayContract(params) {
        return vue.$http({
          method: 'GET',
          url: `/shop/wxpay/queryPapayContract`,
          params: {
            ...params
          }
        })
      },
      queryPapayContractOrder(params) {
        return vue.$http({
          method: 'GET',
          url: `/shop/wxpay/queryPapayContractOrder`,
          params: {
            ...params
          }
        })
      }
    }
  }
}